import React, { FC, useState } from "react";

import {
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  Switch,
  Chip,
  Grid,
} from "@components/base";

const Selects: FC = () => {
  const [multiselectValue, setMultiselectValue] = useState<number[]>([]);
  const [isError, setIsError] = useState(false);

  const options = Array.from({ length: 3 }).map((_, index) => (
    <MenuItem value={index} key={index}>
      Option {index + 1}
    </MenuItem>
  ));

  const chipOptions = Array.from({ length: 3 }).map((_, index) => (
    <MenuItem value={index} key={index}>
      <Chip label={`Chip ${index + 1}`} color="blue1" />
    </MenuItem>
  ));

  return (
    <Stack spacing={4}>
      <Typography variant="h2">Selects</Typography>
      <Divider />
      <Stack spacing={4} direction={"row"}>
        <FormControlLabel
          value={isError}
          control={<Switch />}
          onChange={() => setIsError(!isError)}
          label="isError"
        />
      </Stack>
      <Divider />
      <Grid container spacing={4}>
        <Grid size={6}>
          <Stack spacing={4}>
            <Stack spacing={2}>
              <Typography variant="subtitle1">Default with label</Typography>
              <FormControl error={isError}>
                <InputLabel>Label</InputLabel>
                <Select>{options}</Select>
              </FormControl>
            </Stack>
            <Stack spacing={2}>
              <Typography variant="subtitle2">with Chip</Typography>
              <FormControl error={isError}>
                <InputLabel>Label</InputLabel>
                <Select>{chipOptions}</Select>
              </FormControl>
            </Stack>
            <Stack spacing={2}>
              <Typography variant="subtitle2">with Chip multiselect</Typography>
              <FormControl error={isError}>
                <InputLabel>Label</InputLabel>
                <Select
                  value={multiselectValue}
                  multiple
                  onChange={(event) =>
                    setMultiselectValue(event.target.value as number[])
                  }
                >
                  {chipOptions}
                </Select>
              </FormControl>
            </Stack>
            <Divider />
            <Stack spacing={2}>
              <Typography variant="subtitle1">Filled with placeholder</Typography>
              <Select variant="filled" displayEmpty error={isError}>
                <MenuItem value={undefined} disabled>
                  None
                </MenuItem>
                {options}
              </Select>
              <Typography variant="subtitle2">small</Typography>
              <Select variant="filled" size="small" displayEmpty error={isError}>
                <MenuItem value={undefined} disabled>
                  None
                </MenuItem>
                {options}
              </Select>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Selects;
